<template>
   <v-btn :disabled="disabled"
    :loading="loading"
    :style="{
      minWidth: '35px',
      maxWidth: '35px',
      minHeight: '35px',
      maxHeight: '35px'
    }"
    v-on="$listeners"
    icon>
      <v-icon>{{ icons }}</v-icon>
   </v-btn>
</template>

<script>
export default {
  props: ["icons", "disabled", "loading"],
};
</script>
